import CardFront from "./CardFront";

export default CardFront;
